import React, { useEffect } from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import CandidateHeaderSection from './candidateHeaderSection/candidateHeadersection';
import CandidateSearchSection from './candidateSearchSection/candidateSearchSection';
import CandidateDashboardSection from './candidateDashboardSection/candidateDashboardSection';
import CandidateYearSection from './candidateYearSection/candidateYearSection';
import CandidateBodySection from './candidateBodySection/candidateBodySection';
import CandidateContactSection from './candidateContactSection/candidateContactSection';

const CandidateHomePage = () => {

  useEffect(() => {
    const savedPosition = sessionStorage.getItem("initialScrollPosition");
    if (savedPosition) {
      window.scrollTo(0, parseInt(savedPosition, 10));
      sessionStorage.removeItem("initialScrollPosition");
    }
  }, []);

  return (
    <div className="fluid-container">
      <CandidateHeaderSection />
      <CandidateSearchSection />
      <CandidateDashboardSection />
      <CandidateYearSection />
      <CandidateBodySection />
      <CandidateContactSection />
    </div>
  );
};

export { CandidateHomePage };
